// Lender data — INDICATIVE figures only, clearly labeled in UI
export const LENDERS = {
  "hdfc-bank": {
    name: "HDFC Bank", short: "HDFC", color: "#004C8F", icon: "Landmark",
    personal: { rate: "10.50% – 21.00%", maxAmount: "₹40 Lakh", tenure: "12 – 60 months", procFee: "Up to 2.5%" },
    business: { rate: "11.90% – 21.35%", maxAmount: "₹75 Lakh", tenure: "12 – 48 months", procFee: "Up to 2.0%" },
  },
  "icici-bank": {
    name: "ICICI Bank", short: "ICICI", color: "#B02A30", icon: "Landmark",
    personal: { rate: "10.85% – 16.65%", maxAmount: "₹50 Lakh", tenure: "12 – 72 months", procFee: "Up to 2.5%" },
    business: { rate: "12.50% – 19.00%", maxAmount: "₹2 Crore", tenure: "12 – 48 months", procFee: "Up to 2.0%" },
  },
  "axis-bank": {
    name: "Axis Bank", short: "Axis", color: "#97144D", icon: "Landmark",
    personal: { rate: "9.99% – 22.00%", maxAmount: "₹40 Lakh", tenure: "12 – 60 months", procFee: "Up to 2.0%" },
    business: { rate: "14.25% – 21.00%", maxAmount: "₹75 Lakh", tenure: "12 – 60 months", procFee: "Up to 2.0%" },
  },
  "kotak-mahindra-bank": {
    name: "Kotak Mahindra Bank", short: "Kotak", color: "#ED1C24", icon: "Landmark",
    personal: { rate: "10.99% – 20.00%", maxAmount: "₹35 Lakh", tenure: "12 – 60 months", procFee: "Up to 3.0%" },
    business: { rate: "16.00% – 22.00%", maxAmount: "₹75 Lakh", tenure: "12 – 48 months", procFee: "Up to 2.5%" },
    overdraft: { rate: "12.50% – 18.00%", maxAmount: "₹2 Crore", tenure: "12 – 60 months", procFee: "Up to 2.0%" },
  },
  "idfc-first-bank": {
    name: "IDFC FIRST Bank", short: "IDFC FIRST", color: "#9B1B30", icon: "Landmark",
    personal: { rate: "9.99% – 25.00%", maxAmount: "₹1 Crore", tenure: "12 – 60 months", procFee: "Up to 3.5%" },
    business: { rate: "14.50% – 24.00%", maxAmount: "₹1 Crore", tenure: "12 – 48 months", procFee: "Up to 2.5%" },
  },
  "indusind-bank": {
    name: "IndusInd Bank", short: "IndusInd", color: "#9F1D35", icon: "Landmark",
    personal: { rate: "9.99% – 26.00%", maxAmount: "₹50 Lakh", tenure: "12 – 60 months", procFee: "Up to 3.0%" },
    business: { rate: "14.00% – 22.00%", maxAmount: "₹1 Crore", tenure: "12 – 60 months", procFee: "Up to 2.5%" },
  },
  "bandhan-bank": {
    name: "Bandhan Bank", short: "Bandhan", color: "#E31E24", icon: "Landmark",
    personal: { rate: "11.55% – 20.00%", maxAmount: "₹25 Lakh", tenure: "12 – 60 months", procFee: "Up to 2.5%" },
    business: { rate: "14.00% – 22.00%", maxAmount: "₹50 Lakh", tenure: "12 – 48 months", procFee: "Up to 2.0%" },
  },
  "yes-bank": {
    name: "Yes Bank", short: "Yes Bank", color: "#00518F", icon: "Landmark",
    personal: { rate: "10.99% – 20.00%", maxAmount: "₹40 Lakh", tenure: "12 – 60 months", procFee: "Up to 2.5%" },
    business: { rate: "13.50% – 21.00%", maxAmount: "₹75 Lakh", tenure: "12 – 60 months", procFee: "Up to 2.0%" },
  },
  "bajaj-finance": {
    name: "Bajaj Finance Ltd", short: "Bajaj Finance", color: "#0033A0", icon: "Building2",
    personal: { rate: "11.00% – 26.00%", maxAmount: "₹55 Lakh", tenure: "12 – 96 months", procFee: "Up to 3.93%" },
    business: { rate: "14.00% – 26.00%", maxAmount: "₹80 Lakh", tenure: "12 – 96 months", procFee: "Up to 2.0%" },
    overdraft: { rate: "13.00% – 18.00%", maxAmount: "₹1 Crore", tenure: "12 – 60 months", procFee: "Up to 2.5%" },
  },
  "aditya-birla-finance": {
    name: "Aditya Birla Finance", short: "Aditya Birla", color: "#A11E2C", icon: "Building2",
    personal: { rate: "12.00% – 28.00%", maxAmount: "₹50 Lakh", tenure: "12 – 60 months", procFee: "Up to 2.5%" },
    business: { rate: "13.00% – 24.00%", maxAmount: "₹1 Crore", tenure: "12 – 60 months", procFee: "Up to 2.0%" },
    overdraft: { rate: "13.50% – 19.00%", maxAmount: "₹2 Crore", tenure: "12 – 60 months", procFee: "Up to 2.0%" },
  },
  "tata-capital": {
    name: "Tata Capital", short: "Tata Capital", color: "#486CA7", icon: "Building2",
    personal: { rate: "11.99% – 24.00%", maxAmount: "₹35 Lakh", tenure: "12 – 72 months", procFee: "Up to 2.75%" },
    business: { rate: "14.00% – 22.00%", maxAmount: "₹75 Lakh", tenure: "12 – 60 months", procFee: "Up to 2.5%" },
    overdraft: { rate: "13.50% – 18.00%", maxAmount: "₹1 Crore", tenure: "12 – 60 months", procFee: "Up to 2.0%" },
  },
  "poonawalla-fincorp": {
    name: "Poonawalla Fincorp", short: "Poonawalla", color: "#3F1F73", icon: "Building2",
    personal: { rate: "10.99% – 24.00%", maxAmount: "₹50 Lakh", tenure: "12 – 60 months", procFee: "Up to 3.0%" },
    business: { rate: "14.00% – 22.00%", maxAmount: "₹50 Lakh", tenure: "12 – 60 months", procFee: "Up to 2.5%" },
  },
  "piramal-finance": {
    name: "Piramal Finance", short: "Piramal", color: "#DC241F", icon: "Building2",
    personal: { rate: "12.99% – 26.00%", maxAmount: "₹25 Lakh", tenure: "12 – 60 months", procFee: "Up to 3.0%" },
    business: { rate: "15.00% – 24.00%", maxAmount: "₹50 Lakh", tenure: "12 – 60 months", procFee: "Up to 2.5%" },
    overdraft: { rate: "14.00% – 20.00%", maxAmount: "₹1 Crore", tenure: "12 – 60 months", procFee: "Up to 2.0%" },
  },
  "axis-finance": {
    name: "Axis Finance", short: "Axis Finance", color: "#97144D", icon: "Building2",
    personal: { rate: "11.50% – 22.00%", maxAmount: "₹50 Lakh", tenure: "12 – 60 months", procFee: "Up to 2.0%" },
    business: { rate: "14.00% – 22.00%", maxAmount: "₹1 Crore", tenure: "12 – 60 months", procFee: "Up to 2.0%" },
  },
  "incred-finance": {
    name: "InCred Finance", short: "InCred", color: "#0E7C66", icon: "Building2",
    personal: { rate: "11.99% – 28.00%", maxAmount: "₹15 Lakh", tenure: "12 – 60 months", procFee: "Up to 3.0%" },
    business: { rate: "14.00% – 24.00%", maxAmount: "₹50 Lakh", tenure: "12 – 60 months", procFee: "Up to 2.5%" },
  },
  "smfg-india-credit": {
    name: "SMFG India Credit", short: "SMFG", color: "#006633", icon: "Building2",
    personal: { rate: "12.50% – 28.00%", maxAmount: "₹30 Lakh", tenure: "12 – 60 months", procFee: "Up to 3.0%" },
    business: { rate: "14.50% – 24.00%", maxAmount: "₹75 Lakh", tenure: "12 – 60 months", procFee: "Up to 2.5%" },
  },
};

export const PERSONAL_LENDERS = [
  "hdfc-bank","icici-bank","axis-bank","kotak-mahindra-bank","idfc-first-bank","indusind-bank",
  "bandhan-bank","yes-bank","bajaj-finance","aditya-birla-finance","tata-capital",
  "poonawalla-fincorp","piramal-finance","axis-finance","incred-finance","smfg-india-credit"
];
export const BUSINESS_LENDERS = PERSONAL_LENDERS;
export const OVERDRAFT_LENDERS = [
  "bajaj-finance","kotak-mahindra-bank","tata-capital","aditya-birla-finance","piramal-finance"
];


export const FAQS = [
  { q: "What types of loans can I apply for through OneLoan.in?", a: "OneLoan.in helps you compare and apply for Personal Loans, Business Loans, and Flexi Overdraft Loans from 16+ leading banks and NBFCs across India." },
  { q: "Is OneLoan.in a bank or NBFC?", a: "No. OneLoan.in is a loan facilitation and distribution platform. Loan approval, interest rates, amounts and terms are decided by the respective banks and NBFCs." },
  { q: "Will checking eligibility affect my credit score?", a: "No. Our soft eligibility check does not impact your credit score. A hard enquiry only happens when you formally submit an application to a chosen lender." },
  { q: "How long does loan disbursal take?", a: "For salaried applicants with complete documents, disbursal can be as fast as 24-72 hours. Business loans typically take 5-10 working days." },
  { q: "Is my data secure?", a: "Yes. All data is transmitted over 256-bit SSL and stored encrypted. We never share your information without your consent." },
  { q: "Are there any charges for using OneLoan.in?", a: "No. Our comparison and application service is completely free for end users. We earn commissions from partner lenders only upon successful disbursal." },
];
